import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import FullScreenHeroCarousel from "../../components/HeroCarousel/FullScreenHeroCarousel";

import Collections from "../../components/Homepage/Collections/Collections";
import Delivery from "../../components/Homepage/Delivery/Delivery";
import Offerings from "../../components/Homepage/Offerings/Offerings";
import Promotions from "../../components/Homepage/Promotions/Promotions";
import ActiveOrders from "../../components/ActiveOrders/ActiveOrders";

import { isBrandRefreshEnabled } from "../../shared/utilities/brandRefresh";
import ProductsHeader from "../../components/ProductsHeader/ProductsHeader";
import endpoints from "../../shared/constants/endpoints";
import * as addressActions from "../../redux/actions/address";
import * as cms from "../../shared/repos/cms/cms";
import cmsKeys from "../../shared/constants/cms";
import Loader from "../../components/Loader/Loader";
import { getContentsByKey } from "../../shared/utilities/common";

import styles from "./Homepage.module.css";
import Banner from "../../components/Homepage/Banner/Banner";
import { amplitudeDeliveryWidgetPageSection } from "../../shared/constants/amplitudeDeliveryWidgetPageSections";

class Homepage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: [],
      loading: true,
      showDeliveryWidget: false,
      /* Default: below-hero strip (Delivery.jsx). Hero CMS card sets Hero Content Card in openDeliveryWidget. */
      deliveryWidgetAnalyticsSection:
        amplitudeDeliveryWidgetPageSection.belowHero,
    };
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    cms.getContent([cmsKeys.homePage], this);
  };

  openDeliveryWidget = (hash = null, pageSection) => {
    const { userAddress, history, setRedirectUrl } = this.props;
    setRedirectUrl(hash);
    if (!userAddress) {
      this.setState({
        showDeliveryWidget: true,
        deliveryWidgetAnalyticsSection:
          pageSection ||
          amplitudeDeliveryWidgetPageSection.heroContentCard,
      });
    } else {
      const url = hash ? `${endpoints.menu}#${hash}` : endpoints.menu;

      history.push(url);
    }
  };

  setShowDeliveryWidget = (show = false, pageSection) => {
    this.setState({
      showDeliveryWidget: show,
      ...(show && pageSection
        ? {
            deliveryWidgetAnalyticsSection: pageSection,
          }
        : {}),
    });
  };

  render() {
    const { content, loading, showDeliveryWidget, deliveryWidgetAnalyticsSection } =
      this.state;
    const { userToken, cmsEditMode, isContentCardFullWidth, useFullscreenCarousel } = this.props;

    if (!content.length && !loading) {
      return <Loader />;
    }

    const components = content[0]?.children;
    const collections = getContentsByKey(components, "collections");
    const banner = getContentsByKey(components, "banner");
    const offers = getContentsByKey(components, "offers");
    const promotions = getContentsByKey(components, "promotions");

    return (
      <div
        className={`
        w-full flex flex-col items-center pb-36 mx-auto dark:bg-gradient-bl dark:bg-gradient-to-br dark:from-darkBlack dark:to-darkBlack
        `}
      >
        {userToken && (
          <div className={styles.activeOrdersWrapper}>
            <ActiveOrders />
          </div>
        )}
        <div className="dark:bg-dark w-full">
          <div className={`${!isContentCardFullWidth ? 'lg:max-w-screen-desktop' : ''} w-full flex flex-col p-0 border-0 mx-auto`}>
            {!isContentCardFullWidth && (
              <Delivery
                showWidget={showDeliveryWidget}
                setShowDeliveryWidget={this.setShowDeliveryWidget}
                analyticsPageSection={deliveryWidgetAnalyticsSection}
              />
            )}
            <div className="w-full">
              {useFullscreenCarousel ? (
                <div
                  style={{
                    position: 'fixed',
                    top: 'var(--content-top-offset, 0px)',
                    left: 0,
                    width: '100%',
                    height: 'calc(100vh - var(--content-top-offset, 0px))',
                    overflow: 'hidden',
                    zIndex: 9999
                  }}
                >
                  <FullScreenHeroCarousel
                    openDeliveryWidget={this.openDeliveryWidget}
                  />
                </div>
              ) : (
                <ProductsHeader
                  floatMenuHide="true"
                  openDeliveryWidget={(hash) =>
                    this.openDeliveryWidget(
                      hash,
                      amplitudeDeliveryWidgetPageSection.heroContentCard
                    )}
                />
              )}
            </div>
            {isContentCardFullWidth && (
              <Delivery
                showWidget={showDeliveryWidget}
                setShowDeliveryWidget={this.setShowDeliveryWidget}
                analyticsPageSection={deliveryWidgetAnalyticsSection}
              />
            )}
          </div>
        </div>
        {!useFullscreenCarousel && (
          <div className="w-full flex flex-col items-center">
            <div className="w-full dark:bg-dark p-0 m-0 border-0 flex flex-col gap-11">
              <Collections
                contents={collections}
                openDeliveryWidget={(hash) =>
                  this.openDeliveryWidget(
                    hash,
                    amplitudeDeliveryWidgetPageSection.categoryCarousel
                  )}
              />
              <div className="w-full dark:bg-gradient-to-b dark:from-darkBlack dark:to-dark bg-white border-0">
                <Banner
                  contents={banner}
                  openDeliveryWidget={(hash) =>
                    this.openDeliveryWidget(
                      hash,
                      amplitudeDeliveryWidgetPageSection.buildYourOwnPack
                    )}
                  cmsEditMode={cmsEditMode}
                />
                <Offerings
                  openDeliveryWidget={(hash) =>
                    this.openDeliveryWidget(
                      hash,
                      amplitudeDeliveryWidgetPageSection.categoryImages
                    )}
                  contents={offers}
                />
              </div>
            </div>
            <Promotions contents={promotions} />
          </div>
        )}
      </div>
    );
  }
}

Homepage.propTypes = {
  userAddress: PropTypes.shape({}),
  userToken: PropTypes.string || null,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,
  setRedirectUrl: PropTypes.string,
  selectedCountry: PropTypes.shape({}),
  cmsEditMode: PropTypes.bool,
  isContentCardFullWidth: PropTypes.bool,
  useFullscreenCarousel: PropTypes.bool
};

Homepage.defaultProps = {
  userAddress: null,
  userToken: null,
  setRedirectUrl: "",
  selectedCountry: null,
  cmsEditMode: false,
  isContentCardFullWidth: false,
  useFullscreenCarousel: isBrandRefreshEnabled()
};

export const mapStateToProps = state => {
  const { userAddress, userToken, cmsEditMode } = state.user;
  const { selectedCountry } = state.country;
  const { isContentCardFullWidth } = state.elements;
  return { userAddress, userToken, selectedCountry, cmsEditMode, isContentCardFullWidth};
};

export const mapDispatchToProps = dispatch => ({
  setRedirectUrl: value => dispatch(addressActions.setRedirectUrl(value))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Homepage);
